<template>
	<div id="dorm_bottom1">
		<div class="main-value week_att">
			<div class="normal-header">宿舍楼周出勤趋势统计
				<div class="title_tab">
					<div class="legend-color greenbg"></div>归宿
					<div class="legend-color yellowbg" style="margin-left: 0.15rem;"></div>请假
					<div class="legend-color redbg" style="margin-left: 0.15rem;"></div>未归
				</div>
			</div>
			<div id="week_echarts"></div>
		</div>
	</div>
</template>

<script>
var storage = window.localStorage;
var orgId = storage.getItem("orgId");
var buildIds = storage.getItem("buildIds");
const echarts = require("echarts");
export default {
	data() {
		return {
			config: {
				time: '00:00:00', // 每天几点执行
				interval: 1, // 隔几天执行一次
				runNow: true, // 是否立即执行
				intervalTimer: '',
				timeOutTimer: ''
			}
		};
	},
	mounted() {
		this.initData();
		this.createTimer();
	},
	beforeDestroy() {
		console.log(
			'关闭任务定时器',
			this.config.intervalTimer
		)
		clearInterval(this.config.intervalTimer)
		console.log('清除定时器timeout', this.config.timeOutTimer)
		clearTimeout(this.config.timeOutTimer)
	},
	methods: {
		createTimer() {
			if (this.config.runNow) {
				this.runTimer()		// 如果配置了立刻运行则立刻运行任务函数
			}
			// 获取下次要执行的时间，如果执行时间已经过了今天，就让把执行时间设到明天的按时执行的时间
			var nowTime = new Date().getTime()
			var timePoint = this.config.time.split(':').map((i) => parseInt(i))
			var recent = new Date().setHours(...timePoint) // 获取执行时间的时间戳
			if (recent <= nowTime) {
				recent += 24 * 60 * 60 * 1000
			}
			// 未来程序执行的时间减去现在的时间，就是程序要多少秒之后执行
			var doRunTime = recent - nowTime
			this.config.timeOutTimer = setTimeout(this.setTimer, doRunTime)
		},
		setTimer() {
			console.log('进入定时器')
			this.runTimer()
			// 每隔多少天再执行一次
			var intTime = this.config.interval * 24 * 60 * 60 * 1000
			this.config.intervalTimer = setInterval(this.runTimer, intTime)
		},
		runTimer() {
			console.log("正在执行定时任务.......ing.....")
			this.initData();
		},
		initData() {
			// 基于准备好的dom，初始化echarts实例
			let weekCensusChart = echarts.init(document.getElementById("week_echarts"));
			this.$http.get("/dataView/dorm/weekCensus?orgId=" + orgId + "&buildIds=" + buildIds).then(res => {
				if (res.data.code === 200) {
					var xData = res.data.result.xData;
					var yData1 = res.data.result.yData1;
					var yData2 = res.data.result.yData2;
					var yData3 = res.data.result.yData3;
					var option = {
						color: ['#00d587', '#e7d808', '#ff5959'],
						tooltip: {
							trigger: 'axis',
							axisPointer: {
								type: 'cross',
								label: {
									backgroundColor: '#6a7985'
								}
							}
						},
						grid: {
							x: 46,
							top: "10%",
							bottom: "25%",
						},
						xAxis: [{
							type: 'category',
							boundaryGap: false,
							data: xData,
							axisLabel: {
								textStyle: {
									color: '#d3d6ff',
									fontSize: fontSize(0.15)
								}
							}
						}],
						yAxis: [{
							type: 'value',
							splitLine: {
								show: true,
								lineStyle: {
									width: 1,
									color: 'rgba(255, 255, 255, 0.2)',
								}
							},
							axisLabel: {
								textStyle: {
									color: '#d3d6ff',
									fontSize: fontSize(0.13)
								}
							},
							axisLine: {
								show: true
							},
						}],
						series: [{
							type: 'line',
							name: '归宿',
							smooth: true,
							lineStyle: {
								width: 0
							},
							showSymbol: false,
							areaStyle: {
								opacity: 0.8,
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: "#24aa8f" // 0% 处的颜色
								}, {
									offset: 1,
									color: "#19ff9f" // 100% 处的颜色
								}])
							},
							emphasis: {
								focus: 'series'
							},
							data: yData1
						},
						{
							type: 'line',
							name: '请假',
							smooth: true,
							lineStyle: {
								width: 0
							},
							showSymbol: false,
							areaStyle: {
								opacity: 0.8,
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: "#ffaa00" // 0% 处的颜色
								}, {
									offset: 1,
									color: "#ffd94e" // 100% 处的颜色
								}])
							},
							emphasis: {
								focus: 'series'
							},
							data: yData3
						},
						{
							type: 'line',
							name: '未归',
							smooth: true,
							lineStyle: {
								width: 0
							},
							showSymbol: false,
							areaStyle: {
								opacity: 0.8,
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: "#ffa0a2" // 0% 处的颜色
								}, {
									offset: 1,
									color: "#ff6063" // 100% 处的颜色
								}])
							},
							emphasis: {
								focus: 'series'
							},
							data: yData2
						}
						]
					};
					weekCensusChart.setOption(option);
					// 响应式变化
					window.addEventListener("resize", () => weekCensusChart.resize(), false);
				}
			})
		}
	},
	destroyed() {
		window.onresize = null;
	}
};

function fontSize(res) {
	let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	if (!clientWidth) return;
	let fontSize = 100 * (clientWidth / 1920);
	return res * fontSize;
}
</script>

<style lang="scss">
#dorm_bottom1 {
	height: 100%;
	padding-right: 2%;

	.week_att {
		width: 100%;
	}

	.normal-header {
		padding: 0.3rem 0 0 0.4rem;

		.title_tab {
			position: absolute;
			right: 0.5rem;
			font-size: 0.2rem;
			height: 0.15rem;
			line-height: 0.15rem;
			display: flex;
			align-items: center;

			.legend-color {
				display: inline-block;
				width: 0.2rem;
				height: 0.15rem;
				border-radius: 15%;
				margin-right: 0.05rem;
			}
		}
	}

	#week_echarts {
		width: 100%;
		height: 100%;
		margin-left: 0.2rem;
	}

	@media screen and (min-width: 768px) and (max-width: 992px) {}

	@media screen and (min-width: 1200px) and (max-width: 1920px) {}
}
</style>
